exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-item[data-v-06320b74]{padding-left:20px}.active[data-v-06320b74]{color:#0061ca!important}.header[data-v-06320b74]{top:0;left:0;width:100%;margin:auto;background:#fff;height:117px;z-index:99999}", "", {"version":3,"sources":["/./src/components/web/WebHeader.vue"],"names":[],"mappings":"AACA,2BACE,iBAAmB,CACpB,AACD,yBACE,uBAA0B,CAE3B,AACD,yBACE,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,gBAAoB,AACpB,aAAc,AAEd,aAAe,CAChB","file":"WebHeader.vue","sourcesContent":["\n.tab-item[data-v-06320b74] {\n  padding-left: 20px;\n}\n.active[data-v-06320b74] {\n  color: #0061ca !important;\n  /*background: #0061ca !important;*/\n}\n.header[data-v-06320b74] {\n  top: 0;\n  left: 0;\n  width: 100%;\n  margin: auto;\n  background: #FFFFFF;\n  height: 117px;\n  /* position: fixed; */\n  z-index: 99999;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-06320b74&scoped=true!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/components/web/WebHeader.vue
// module id = 207
// module chunks = 0